import { useMediaQuery } from "react-responsive";
import { DefaultCarPageComponentProps } from "@/app/interface/components";
import NavBarMobile from "./NavBarMobile";
import NavBarDesktop from "./NavBarDesktop";

interface HeaderProps extends DefaultCarPageComponentProps {
  show?: boolean;
}

export const NavBar = ({
  car,
  model,
  version,
  color,
  setModel,
  setVersion,
  setColor,
  show,
}: HeaderProps) => {
  const isDesktop = useMediaQuery({ minWidth: 1140 });

  return isDesktop ? (
    <NavBarDesktop
      car={car}
      model={model}
      version={version}
      color={color}
      setModel={setModel}
      setVersion={setVersion}
      setColor={setColor}
    />
  ) : (
    <NavBarMobile
      car={car}
      model={model}
      version={version}
      color={color}
      setModel={setModel}
      setVersion={setVersion}
      setColor={setColor}
      show={show || false}
    />
  );
};

export default NavBar;
